const wordLooper = () => {

	const wordTarget = document.querySelector('.site-header .word-wrapper')
	let currentIndex = 0;

	function displayWord() {
		if (currentIndex >= words.length) {
			currentIndex = 0
		}

		wordTarget.innerHTML = words[currentIndex]
		wordTarget.href = '#' + words[currentIndex]
		currentIndex++
	}

	const interval = setInterval(displayWord, 2000)
}

export default wordLooper;
